import * as PhosphorIcons from '@phosphor-icons/react';
import React, { useState, useRef, useEffect } from 'react';
import CustomTooltip from '../../../components/tooltip/CustomTooltip';

const SUBJECT_TOOLTIP_TEXTS = {
  phy: 'Combined Physics score from both papers.',
  chem: 'Combined Chemistry score from both papers.',
  math: 'Combined Mathematics score from both papers.',
};

export default function SubjectScoreCard({ subject }) {
  const [clickedOpen, setClickedOpen] = useState(false);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!clickedOpen) return;

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setClickedOpen(false);
        setIsTooltipOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [clickedOpen]);

  const getTooltipText = (title) => {
    if (!title) return '';
    const key = title.toLowerCase();
    return SUBJECT_TOOLTIP_TEXTS[key] || '';
  };

  const getPaperLabel = (label = '') => {
    const match = label.match(/Paper\s*\d+/i);
    return match ? match[0] : label;
  };

  return (
    <CustomTooltip
      text={getTooltipText(subject.title)}
      open={isTooltipOpen || clickedOpen}
      onOpenChange={(val) => {
        if (!clickedOpen) {
          setIsTooltipOpen(val);
        }
      }}
    >
      <div
        ref={wrapperRef}
        className="rounded-xl p-[2px] min-w-[280px] w-full "
        style={{
          background: `linear-gradient(180deg,var(--q3-stroke-light),${subject.color}40)`,
        }}
      >
        <div className=" rounded-xl px-4 py-4 flex flex-col justify-between gap-6 h-full bg-[var(--q3-surface-default)] cursor-pointer">
          <div className="flex flex-row items-center justify-between">
            <div className="flex flex-row items-center gap-1.5 min-w-0">
              <img src={subject.icon} alt={subject.title} className="h-4 w-4" />
              <span className="text-[var(--q3-neutral-light)] text-xs font-semibold leading-tight truncate uppercase">
                {subject.title} SCORE
              </span>
            </div>

            <div className="flex items-center shrink-0 ml-1">
              <PhosphorIcons.Info
                size={16}
                color="var(--q3-neutral-light)"
                className="cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  const next = !clickedOpen;
                  setClickedOpen(next);
                  setIsTooltipOpen(next);
                }}
              />
            </div>
          </div>

          <div className="flex flex-row items-end gap-18 mt-1">
            <p className="text-[var(--q3-neutral-default)] font-bold text-4xl leading-none whitespace-nowrap">
              {subject.markScored}
              <span className="text-[var(--q3-neutral-light)] text-sm font-normal">/{subject.totalScore}</span>
            </p>

            {subject.papers && subject.papers.length > 0 && (
              <div className="flex flex-row gap-4 ">
                {subject.papers.map((paper, index) => (
                  <p
                    key={index}
                    className="text-[var(--q3-neutral-light)] text-xs leading-tight whitespace-nowrap flex flex-col gap-1"
                  >
                    {getPaperLabel(paper.label)}:{' '}
                    <span className="text-[var(--q3-neutral-light)] font-bold">
                      {paper.markScored}/{paper.totalScore}
                    </span>
                  </p>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </CustomTooltip>
  );
}
